import { namesPattern } from 'shared/regex/regex';
import { StrictEmailValidation } from 'utils/form/validation';
import * as yup from 'yup';
import { cachedGetIsEmailAlreadyInUse } from '../../api';
import { ACCOUNT_ROLE, FIELD, USER_SOURCE_VALUE } from './types';

export enum CUSTOM_ERROR {
  EMAIL_DUPLICATE = 'EMAIL_DUPLICATE',
}

export const validationSchema = () =>
  yup.object().shape({
    [FIELD.FIRST_NAME]: yup
      .string()
      .nullable()
      .matches(namesPattern, { message: 'First name is invalid' })
      .required('This field is required'),
    [FIELD.SURNAME]: yup
      .string()
      .nullable()
      .matches(namesPattern, { message: 'Surname is invalid' })
      .required('This field is required'),
    [FIELD.EMAIL]: StrictEmailValidation()
      .nullable()
      .required('This field is required')
      .test({
        name: CUSTOM_ERROR.EMAIL_DUPLICATE,
        test: async function(value: string) {
          let isValidEmail = true;
          try {
            StrictEmailValidation().validateSync(value);
          } catch (error) {
            isValidEmail = false;
          }
          if (value && isValidEmail) {
            const { isExists } = await cachedGetIsEmailAlreadyInUse(value);

            return isExists
              ? this.createError({
                  path: FIELD.EMAIL,
                })
              : true;
          }
          return true;
        },
      }),
    [FIELD.ROLE]: yup
      .string()
      .nullable()
      .oneOf([ACCOUNT_ROLE.ADVISER, ACCOUNT_ROLE.ADVISER_SUPPORT], 'Please select an option'),
    [FIELD.CONTACT_NUMBER]: yup
      .string()
      .nullable()
      .required('This field is required')
      .matches(/[0]\d{4}(\s\d{3}\s\d{3}|\d{6})/, `Please enter a valid phone number.`)
      .test('len', `Please enter a valid phone number.`, (val) => {
        return val ? val.trim().length > 10 : true;
      }),
    [FIELD.HOW_DID_USER_HEAR_ABOUT_LIVEMORE]: yup
      .string()
      .nullable()
      .oneOf(
        [
          USER_SOURCE_VALUE.GOOGLE_SEARCH,
          USER_SOURCE_VALUE.WORD_OF_MOUTH,
          USER_SOURCE_VALUE.SOCIAL_MEDIA,
          USER_SOURCE_VALUE.PR,
          USER_SOURCE_VALUE.COMMS_FROM_LIVEMORE,
          USER_SOURCE_VALUE.COMMS_FROM_MY_NETWORK_PR,
          USER_SOURCE_VALUE.SOURCING_SYSTEM_ADS,
          USER_SOURCE_VALUE.WEBINAR,
          USER_SOURCE_VALUE.ROADSHOW_EVENT,
          USER_SOURCE_VALUE.BUSINESS_DEVELOPMENT_CALL,
          USER_SOURCE_VALUE.NETWORK_LAUNCH,
          USER_SOURCE_VALUE.OTHER,
        ],
        'Please select an option',
      ),
    [FIELD.OPTIONAL_DETAILS]: yup
      .string()
      .nullable()
      .when(FIELD.HOW_DID_USER_HEAR_ABOUT_LIVEMORE, {
        is: (val): any =>
          [
            USER_SOURCE_VALUE.ROADSHOW_EVENT,
            USER_SOURCE_VALUE.BUSINESS_DEVELOPMENT_CALL,
            USER_SOURCE_VALUE.OTHER,
          ].includes(val),
        then: yup
          .string()
          .nullable()
          .required('This field is required'),
      }),
  });
